import { packingIndentEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class IndentDTO {
    @ApiProperty()
    indentNumber:string
}

export class IndentRequest{
    indentNumber:string
    status:packingIndentEnum;
    receivedQuantity?:number;
    issuedQuantity?:number;


    
}